import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';

import { UtilsService } from './../../../../resources/services/utils.service';
import { NotificationsComponent } from './../../../../resources/components/notifications/notifications.component';
import { environment } from './../../../../../environments/environment';
import { TratamientosDatosComponent } from '../condiciones/tratamiento-datos.component';
import { DAcuseRebicoMFATO, DAuthMFATO, DConsumirMFATO, DSesionServicios } from '@dian-api/api-sesion';
import { BehaviorSubject, Subject } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { map, takeUntil } from 'rxjs/operators';

const listOptions = [
  {
    id: 1,
    texto: 'A nombre propio',
    icono: './assets/img/svg/nombre-propio.svg',
    iconoSeleccionado: './assets/img/svg/b-nombre-propio.svg',
    seleccionado: false,
    disabled: false  
  },
  {
    id: 2,
    texto: 'A nombre de un tercero',
    icono: './assets/img/svg/terceros.svg',
    iconoSeleccionado: './assets/img/svg/b-terceros.svg',
    seleccionado: false,
    disabled: false
  },
  {
    id: 3,
    texto: 'Servidor DIAN',
    icono: './assets/img/svg/servidor-dian.svg',
    iconoSeleccionado: './assets/img/svg/b-servidor.svg',
    seleccionado: false,
    disabled: false 
  },
  {
    id: 4,
    texto: 'Autorizaciones / Poderes',
    icono: './assets/img/svg/autorizaciones.svg',
    iconoSeleccionado: './assets/img/svg/b-autorizaciones.svg',
    seleccionado: false,
    disabled: false    
  },
  {
    id: 5,
    texto: 'Organización no obligada a RUT',
    icono: './assets/img/svg/no-rut.svg',
    iconoSeleccionado: './assets/img/svg/b-no-rut.svg',
    seleccionado: false,
    disabled: false   
  }
];

const tipoForms: SeleccionDatosForm[] = [
  {
    id: 1,
    valor: "2",
    titulo: 'A nombre propio',
    subtitulo: 'Como persona natural gestione sus trámites, servicios y consultas.',
    form: ['tipoDocumento', 'numDocumento', 'password']  
  },
  {
    id: 2,
    valor: "0",
    titulo: 'A nombre de un tercero',
    subtitulo: 'Gestione trámites, servicios y consultas a nombre de una persona natural o jurídica.',
    form: ['nit', 'tipoDocumento', 'numDocumento', 'password']
  },
  {
    id: 3,
    valor: "1",
    titulo: 'Servidor DIAN',
    subtitulo: 'Gestione trámites y servicios de acuerdo con sus funciones en la entidad.',
    form: ['tipoDocumento', 'numDocumento', 'password', 'otp']
  },
  {
    id: 4,
    valor: "1004",
    titulo: 'Autorizaciones / Poderes',
    subtitulo: 'Como persona natural, consulte autorizaciones o poderes otorgados e interactúe con los servicios según el rol o tarea asignada.',
    form: ['tipoDocumento', 'numDocumento', 'password']
  },
  {
    id: 5,
    valor: "10910322",
    titulo: 'Organización no obligada a RUT',
    subtitulo: 'Interactúe con los servicios dispuestos para este tipo de organización.',
    form: ['nit', 'tipoDocumento', 'numDocumento', 'password']
  }
];


class SeleccionDatosForm {
  id: number;
  valor: string;
  titulo: string;
  subtitulo: string;
  form: Array<string>;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    UtilsService,
    DSesionServicios
  ]
})
export class LoginComponent implements OnInit { 

  @ViewChild('formSend', { read: ElementRef })
  public formSend: ElementRef;
  aceptaTratamientoDatos = false;
  listOptions = [];
  seleccionDatosForm: SeleccionDatosForm = tipoForms[0];
  esMuisca: boolean = true;
  usuarioModel: any;
  uriPost: string;
  origin: string = window.location.origin;
  tipoUsuario: string;
  crearUsuarioNoObligado: boolean = false;
  invalidNumDoc: boolean = false;
  invalidNumDocOrg: boolean = false;
  labelNIT: string = 'NIT del tercero (sin dígito de verificación)';
  originalPassword:string='';
  passwordCifrada=false;
  //private validacionRecaptcha: boolean = false;
  private ideRequest: string;
  private urlNoObligadosRUT: string = environment.redirects.noObligadosRUT;
  keyCaptcha = environment.captchaKeyCloudflare;
  disableInputs = false;
  isLoading = false;
  disabledOTP = true;
  private idTransaccion: string = '';
  habilitadoMFA: boolean = false;
  reload = false;

  showCountdown: boolean = false;  
  countdown$ = new BehaviorSubject<string>('01:00');
  private stop$ = new Subject<void>();

  constructor(
    private activatedRouter: ActivatedRoute,
    private renderer2: Renderer2,
    private _utils: UtilsService,
    private dialog: MatDialog,
    private router: Router,
    private dSessionService: DSesionServicios
  ) { 
    this.usuarioModel = {
      aNombreDe: "",
      numDocumentoOrg: null,
      tipoDoc: "",
      numDoc: null,
      password: null,
      clientId: null,
      redirectUri: null,
      ideRequest: null
    }
  }

  ngOnInit() {
    
    localStorage.removeItem('identificacion');
    localStorage.removeItem('medios-comunicacion');
    sessionStorage.removeItem('idTransaccion');
    this.reload = localStorage.getItem('reload-page') == 'true';

    setTimeout(() => {
      this.checkEnvironment();     
      this.activatedRouter.queryParams.subscribe(params => {
        if (params['ideRequest']) {
          localStorage.removeItem('ideRequest');
          this.startProcessLogin(params['ideRequest']);
        } else {          
          const ideRequest = localStorage.getItem('ideRequest');
          if (!ideRequest) {
            this.showMessage('', 'Esta intentando ingresar de manera incorrecta.');
            return;
          }
          this.startProcessLogin(ideRequest);
        }
        
        if (params['ideAccion']) {    
          const info = decodeURIComponent(params['ideAccion']); 
          const decodedBase64 = this._utils.base64Decode(info);    
          if (decodedBase64 === 'habilitar') {
            this.router.navigate(['/habilitar-cuenta/autenticacion']);
          }

          if (decodedBase64 === 'recuperar') {
            this.router.navigate(['/recuperar-cuenta/autenticacion']);
          }
        }   
      });
    }, 50);        
  }  

  /*onCaptchaSuccess(token: string) {
    if (token) this.validacionRecaptcha = true;
  }*/

  private startProcessLogin(ideRequest: string) {
    try { 
      //Cuando llega de cambio de contraseña
      if (this.reload) {
        localStorage.removeItem('reload-page');
        window.location.reload();
      } 

      const info = decodeURIComponent(ideRequest); 

      //Validate is base 64
      const patttern = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
      if (!info.match(patttern)) {
        window.location.href = window.location.origin + '/WebArquitectura/DefLogin.faces';
        return;
      }

      localStorage.setItem('ideRequest', info);
      this.ideRequest = ideRequest;          
      const decodedBase64 = this._utils.base64Decode(info);  
      const jsonObj = decodedBase64 ? JSON.parse(decodedBase64) : null;
      //const codError = localStorage.getItem('codeError');
 
      if (jsonObj) {
        this.tipoUsuario = jsonObj.params.tipoUsuario;
        this.usuarioModel.clientId = jsonObj.clientId;
        this.usuarioModel.redirectUri = jsonObj.redirect_uri;
        this.crearUsuarioNoObligado = jsonObj.params.no_obligado;
        this.usuarioModel.ideRequest = this.ideRequest;  
        this.esMuisca = this.tipoUsuario === 'muisca'; 

        if (jsonObj['codigo_error']) {
          this.validateError(jsonObj['codigo_error']);                   
        }     
      } else {
        //this.showMessage('Datos incorrectos. Verifique e intente de nuevo');
      }          
    } catch (e) {
      //this.showMessage('Datos incorrectos. Verifique e intente de nuevo');
    } finally {
      this.fillOptions();
    } 
  }

  validateNumDocOrg() {
    if (!this.usuarioModel.numDocumentoOrg) return;
    const specialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const onlyNumers = ['RC', 'TI','CC','CR','TE','CD', 'CE', 'PEP', 'PPT'];
    this.invalidNumDocOrg = specialChars.test(this.usuarioModel.numDocumentoOrg) || !(/^\d+$/).test(this.usuarioModel.numDocumentoOrg);
  }

  validateNumDoc() {
    if (!this.usuarioModel.numDoc) return;
    const specialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const onlyNumers = ['RC', 'TI','CC','CR','TE','CD', 'CE', 'PEP', 'PPT'];
    this.invalidNumDoc = specialChars.test(this.usuarioModel.numDoc);
    if (onlyNumers.indexOf(this.usuarioModel.tipoDoc) > -1) 
      this.invalidNumDoc = !(/^\d+$/).test(this.usuarioModel.numDoc);            
  }

  private showMessage(title: string, message: string, cssClass: string = 'alert-error', isError: boolean = false, enableAccount: boolean = false, ideRequest: string = '') {
    let config = {
      disableClose: true,
      maxWidth: 400,
      data: {
        type: 'error',
        title: title,
        message: message,
        textButton: '',
        valueButton: '',
        classWrap: `alert ${cssClass}`,
        enableAccount: enableAccount,
        ideRequest: ideRequest
      }
    };
    let dialogRef = this.dialog.open(NotificationsComponent, config);
    dialogRef.afterClosed().subscribe(res => {
      if (isError) {
        if (!this.ideRequest) return;
        const decodedBase64 = this._utils.base64Decode(this.ideRequest);                 
        const jsonObj = decodedBase64 ? JSON.parse(decodedBase64) : null;          
        delete jsonObj['codigo_error'];          
        const encodeBase64 = this._utils.utf8ToBase64(JSON.stringify(jsonObj));
        localStorage.setItem('ideRequest', encodeBase64);
        this.ideRequest = encodeBase64;
        const newUrl = `${window.location.origin}/WebIdentidadLogin?ideRequest=${encodeBase64}`;
        window.location.href = newUrl;
      }
    });
  }

  private showMessageMFA(title: string, message: string, type: string = 'error', cssClass: string = 'alert-error') {
    let config = {
      disableClose: true,
      maxWidth: 400,
      data: {
        type: type || 'error',
        title: title,
        message: message,
        textButton: '',
        valueButton: '',
        classWrap: `alert ${cssClass}`       
      }
    };
    this.dialog.open(NotificationsComponent, config);   
  }

  seleccionar(index: number) {
    this.listOptions.map(item => item.seleccionado = false);
    const seleccion = this.listOptions[index];
    this.listOptions[index].seleccionado = true;
    const objEncontrado = tipoForms.find(item => item.id === seleccion.id);
    this.seleccionDatosForm = objEncontrado;
    this.usuarioModel.aNombreDe = objEncontrado.valor;

    this.labelNIT = objEncontrado.id === 5 ? 
      'Número de documento de la organización' : 'NIT del tercero (sin dígito de verificación)';   

    this.usuarioModel.numDocumentoOrg = null;
    this.usuarioModel.tipoDoc = "";
    this.usuarioModel.numDoc = null;
    this.usuarioModel.password = null;
  }

  private fillOptions() {
    this.listOptions = [];

    if (this.esMuisca) {
      this.listOptions = listOptions;
      this.listOptions[0].seleccionado = true;
    } else {
      if (this.tipoUsuario === 'noFuncionario' || this.tipoUsuario === 'funcionario_noFuncionario') {
        this.listOptions.push(listOptions[0]);
        this.listOptions.push(listOptions[1]);
      }
        
      if (this.tipoUsuario === 'funcionario' || this.tipoUsuario === 'funcionario_noFuncionario')
        this.listOptions.push(listOptions[2]);           

      if (this.listOptions.length) {
        this.listOptions[0].seleccionado = true;

        //Inicializa la selección
        const objEncontrado = tipoForms.find(item => item.id === this.listOptions[0].id);
        this.seleccionDatosForm = objEncontrado;
      }
    }
    
    const seleccion = tipoForms.find(item => item.id === this.listOptions[0].id);
    this.usuarioModel.aNombreDe = seleccion.valor;    
  }

  existCampo(campo: string): boolean {  
    return this.seleccionDatosForm.form.indexOf(campo) > -1;
  }

  public autenticar() {
    if (this.usuarioModel.aNombreDe === "1")
      this.submitFuncionarioMFA();
    else
      this.submit();
  }

  private submit() {
    /*if (!this.validacionRecaptcha) {
      this.showMessage('', 'No se pudo superar el captcha.');
      return;
    }*/

    sessionStorage.clear();

    if(!this.passwordCifrada){
      this.originalPassword = this.usuarioModel.password;   
    }
    this.usuarioModel.password = this._utils.utf8ToBase64(this.originalPassword); 
    this.passwordCifrada = true; 

    const form = this.renderer2.createElement('form');
    this.renderer2.setAttribute(form, 'method', "post");
    this.renderer2.setAttribute(form, 'action', this.uriPost);

    //if (this.esMuisca) {
      const inputANombreDe = this.renderer2.createElement('input');    
      this.renderer2.setAttribute(inputANombreDe, 'name', 'aNombreDe');
      this.renderer2.setAttribute(inputANombreDe, 'value', this.usuarioModel.aNombreDe);  
      this.renderer2.appendChild(form, inputANombreDe);
    //}  

    const inputnumDocumentoOrg = this.renderer2.createElement('input');    
    this.renderer2.setAttribute(inputnumDocumentoOrg, 'name', 'numDocumentoOrg');
    this.renderer2.setAttribute(inputnumDocumentoOrg, 'value', this.usuarioModel.numDocumentoOrg);

    const inputtipoDoc = this.renderer2.createElement('input');    
    this.renderer2.setAttribute(inputtipoDoc, 'name', 'tipoDoc');
    this.renderer2.setAttribute(inputtipoDoc, 'value', this.usuarioModel.tipoDoc);

    const inputnumDoc = this.renderer2.createElement('input');    
    this.renderer2.setAttribute(inputnumDoc, 'name', 'numDoc');
    this.renderer2.setAttribute(inputnumDoc, 'value', this.usuarioModel.numDoc);

    const inputpassword = this.renderer2.createElement('input');    
    this.renderer2.setAttribute(inputpassword, 'name', 'password');
    this.renderer2.setAttribute(inputpassword, 'value', this.usuarioModel.password);

    const inputclientId = this.renderer2.createElement('input');    
    this.renderer2.setAttribute(inputclientId, 'name', 'clientId');
    this.renderer2.setAttribute(inputclientId, 'value', this.usuarioModel.clientId);

    const inputredirectUri = this.renderer2.createElement('input');    
    this.renderer2.setAttribute(inputredirectUri, 'name', 'redirectUri');
    this.renderer2.setAttribute(inputredirectUri, 'value', this.usuarioModel.redirectUri);

    const inputIdRequest = this.renderer2.createElement('input');    
    this.renderer2.setAttribute(inputIdRequest, 'name', 'ideRequest');
    this.renderer2.setAttribute(inputIdRequest, 'value', this.usuarioModel.ideRequest);

    const buttonSend = this.renderer2.createElement('button');    
    this.renderer2.setAttribute(buttonSend, 'type', 'submit');

    this.renderer2.appendChild(form, inputnumDocumentoOrg);
    this.renderer2.appendChild(form, inputtipoDoc);
    this.renderer2.appendChild(form, inputnumDoc);
    this.renderer2.appendChild(form, inputpassword);
    this.renderer2.appendChild(form, inputclientId);    
    this.renderer2.appendChild(form, inputredirectUri);    
    this.renderer2.appendChild(form, inputIdRequest);
    this.renderer2.appendChild(form, buttonSend);
      
    this.renderer2.appendChild(this.formSend.nativeElement, form);
    buttonSend.click();        
  }

  public submitFuncionarioMFA() {
    /*if (!this.validacionRecaptcha) {
      this.showMessage('', 'No se pudo superar el captcha.');
      return;
    }*/

    this.disableOptions();
    this.disableInputs = true;
    this.isLoading = true;

    const model = new DAuthMFATO();
    model.tipoAutenticacion = this.usuarioModel.aNombreDe;
    model.tipoDocumento = this.usuarioModel.tipoDoc;
    model.numeroDocumento = this.usuarioModel.numDoc;
    model.claveAcceso = this._utils.utf8ToBase64(this.usuarioModel.password);
    model.numeroOrganizacion = null;
    model.idRequest = this.ideRequest;
    model.fechaSolicitud = new Date().toISOString();

    this.dSessionService.autenticarUsuarioMFA(model).subscribe(
      (res: DAcuseRebicoMFATO) => {
        this.habilitadoMFA = res.habilitadoMFA || false;

        if (!this.habilitadoMFA) {
          this.submit();
          return;
        }          

        if (!res.idTransaccion) {
          this.showMessageMFA("Error obteniendo el id de transacción", "Se ha producido un error interno inesperado en el servidor. Por favor, repórtelo a la DIAN.");
          return;
        }

        this.idTransaccion = res.idTransaccion;
        sessionStorage.setItem('idTransaccion', this.idTransaccion);
        const mensaje = `Se ha enviado un OTP al email ${res.emailEnvio}`;
        this.showMessageMFA('Revise su correo', mensaje, 'success', 'alert-primary'); 
        this.disabledOTP = false;
        this.startCountdown();
        this.isLoading = false;
      },
      error => {
        this.showMessage(error.mensaje, error.descripcion);               
        this.enableOptions();
        this.disableInputs = false;        
        this.isLoading = false;
      },
      () => this.isLoading = false
    );
  }

  public submitConsumirMFAOTP() {    
    if (!this.idTransaccion)
      this.idTransaccion = sessionStorage.getItem('idTransaccion');

    if (!this.idTransaccion) {
      this.showMessageMFA('Transacción invalida', 'Intente autenticarse nuevamente.');         
      return;
    }

    this.isLoading = true;

    const model = new DConsumirMFATO();
    model.idTransaccion = this.idTransaccion;
    model.codigoOTP = this.usuarioModel.otp;
    model.fechaSolicitud = new Date().toISOString();  
    
    this.dSessionService.validarUsuarioMFA(model).subscribe(
      res => {
        //this.isLoading = false;
        this.disableInputs = true;
        this.disableOptions();
        this.showCountdown = false;
        this.submit();                          
      },
      error => {
        this.isLoading = false;        
        this.disableInputs = false;
        this.usuarioModel.otp = "";
        this.showMessage(error.mensaje, error.descripcion);
        
        setTimeout(() => {     
          this.showMessageMFA('Transacción invalida por inactividad', 'Intente autenticarse nuevamente.');         
          this.disabledOTP = true;
          this.enableOptions();    
          this.showCountdown = false;      
        }, 5 * 60 * 1000); //A los 5 min vuelve y arranca el proceso
      },
      () => {
        this.isLoading = false;
        this.disabledOTP = true;
        this.enableOptions();
        this.disableInputs = false;
        this.isLoading = false;
      }
    );
  }

  private disableOptions() {
    this.listOptions.forEach(item => item.disabled = true);
  }

  private enableOptions() {
    this.listOptions.forEach(item => item.disabled = false);
  }

  private checkEnvironment() {
    let uriLocation = window.location.origin
    if (uriLocation.indexOf('localhost') > -1 || uriLocation.indexOf('10.255.149.141:4200') > -1)//|| uriLocation.indexOf('10.255.149.141:4200') > -1
      this.uriPost = "http://10.255.5.184:8080/IdentidadRest_Acceso/api/sts/v1/auth/weblogin";
    else 
      this.uriPost = window.location.origin + "/IdentidadRest_Acceso/api/sts/v1/auth/weblogin";
  }

  private validateError(codError: string) {
    localStorage.setItem('codeError', codError);
    let title = "";
    let message = "";
    let cssClass = "alert-error";
    let enableAccount = false;
    let ideRequest = this.ideRequest;
        
    switch (codError) {     
      case '10001':
        message = "Datos incorrectos o no encontrados. Verifique e intente de nuevo."; //Por favor verifique los datos ingresados e intente nuevamente.
        break;
      case '10002':
        message = "No hay disponibilidad del servicio para la autenticación, Por favor intente mas tarde.";
        break;
      case '10003':
        message = "Ocurrió un error al autenticar el usuario. Verifique los datos e intente de nuevo.";
        break;
      case '10004':
        message = "Datos incorrectos o no encontrados. Verifique e intente de nuevo.";
        break;
      case '10005':
        message = "No se encuentran datos de configuracion para el ClientId suministrado.";
        break;
      case '10006':
        message = "Ha ocurrido un error. Llaves no validas en servicio de autenticación.";
        break;
      case '10007':
        title = 'Su cuenta está deshabilitada';
        message = ``;
        enableAccount = true;
        cssClass = "alert-primary";
        break;
      case '10008':
        message = `Datos incorrectos o no encontrados. Verifique e intente de nuevo.`; //No encontramos sus datos. Conozca cómo inscribirse con este enlace: <a href="https://www.dian.gov.co/atencionciudadano/Agendamiento-de-Citas/Paginas/Inicio.aspx" class="link">aquí</a>.
        break;
      default:
        message = "No hay disponibilidad del servicio para la autenticación, intente mas tarde.";        
        break;
    }

    this.showMessage(title, message ? message : 'Datos incorrectos. Verifique e intente de nuevo', cssClass, true, enableAccount, ideRequest);    
  }

  public redirectNoObligadosRut() {
    window.location.href = this.urlNoObligadosRUT + '?ideRequest=' + this.ideRequest;
  }

  modalTratamientoDatos(){
    let config = {
      disableClose: true,
      maxWidth: '80vw',
      data: {}
    };
    let dialogRef = this.dialog.open(TratamientosDatosComponent, config);
    dialogRef.afterClosed().subscribe(result => {
    //  this.aceptaTratamientoDatos = result;
    }); 
  
  }

  startCountdown() {
    this.showCountdown = true;
    this.stop$.next(); // Detiene cualquier cuenta regresiva anterior si la hay

    const totalSeconds = 1 * 60;

    interval(1000).pipe(
      takeUntil(this.stop$),
      map((elapsed) => {
        const remaining = totalSeconds - elapsed;
        if (remaining <= 0) {
          this.showCountdown = false;
          this.stop$.next(); // Detener el stream
          return '00:00';
        }
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;
        return `${this.pad(minutes)}:${this.pad(seconds)}`;
      })
    ).subscribe((value) => this.countdown$.next(value));
  }

  private pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/login/components/login/login.component.ts